import * as React from 'react';
import { Typography, Tooltip, Icon } from 'antd';
import numeral from 'numeral';

export interface Props {
  children?: React.ReactNode;
  sharePoolTotals?: number;
    totalAllocation?: number;
    sharePoolName?: string;
}

export interface State {}

export default class AllocationTotalView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    var percentageRaw =
      ((this.props.sharePoolTotals ?? 1) / (this.props.totalAllocation ?? 100)) * 100;
    var percentage = Math.round(percentageRaw);
    var textColor = percentageRaw > 100 ? 'red' : percentageRaw == 100 ? 'green' : 'inherit';
    return (
      <Tooltip
        visible={percentageRaw > 100}
        title="The total exceeds the available amount">
        <Typography.Title style={{ color: textColor }} level={4}>
                { this.props.sharePoolName ?? "" } Total: {numeral(this.props.sharePoolTotals).format('0,0')} of {numeral(this.props.totalAllocation).format('0,0')}
           {percentageRaw > 100 && <Icon className="" type="info-circle" />}
          {percentageRaw == 100 && <Icon type="check-circle" />}
        </Typography.Title>{' '}
      </Tooltip>
    );
  }
}
